/* AFS7 - de cart verwijdert de JUISTE regel, werkt ook binnen de lade, en
   abonnementsregels krijgen een tag.

   Wat er mis ging
   ---------------
   sections/afs2-cart.liquid zet op elke -, + en Remove knop het REGELNUMMER:
       data-afs2k-qty="{{ forloop.index }}"
   en stuurt dat als  { line: N }  naar /cart/change.js.

   Een regelnummer is alleen geldig zolang de cart niet van samenstelling
   verandert. De EasyGift-app zet het gratis Shower Combo als eigen regel in de
   cart en haalt hem er weer uit zodra het bedrag onder de drempel zakt. Op dat
   moment schuift alles onder die regel een plek op en wijst elk nummer op de
   pagina naar het verkeerde product. Vandaar dat de hele cart leegliep terwijl
   er maar een ding weg moest.

   Wat dit doet
   ------------
   Vlak na elke render lezen we /cart.js en zetten we de LIJNSLEUTEL van Shopify
   op elke knop. Die sleutel hoort bij een regel, niet bij een plek in de rij, en
   blijft dus kloppen wat de gift-app ook doet. De klik wordt in de capture-fase
   afgevangen, zodat de nummer-versie van het thema niet meer aan bod komt, en we
   sturen { id: sleutel } in plaats van { line: nummer }.

   Let op bij het nameten: de gift-app past de cart AAN NA onze wijziging. Een
   /cart.js die je meteen erna leest kan dus een tussenstand tonen waarin het
   cadeau er nog wel of nog niet is. Dat is geen fout in deze code.

   De lade
   -------
   Daarbinnen komt de cartsectie via innerHTML binnen, en scripts die zo binnen-
   komen draaien niet. De eigen knoppen-JS van het thema doet daar dus niets.
   Daarom vangen we BINNEN de lade ook de cross-sell Add en de tweede-fles-wissel
   af. Buiten de lade laten we die met rust: op de echte cartpagina werkt het
   thema gewoon, en dat willen we niet dubbel doen.

   sections_url staat altijd op /cart. De cartsectie bestaat alleen daar, dus op
   de home page zou het huidige pad niets teruggeven om mee te verversen.

   Dezelfde /cart.js bevat per regel selling_plan_allocation, dus de
   abonnementstag kost geen extra verzoek. Eenmalige aankopen krijgen bewust
   geen tag, anders zegt de tag niets meer. En omdat we het aantal toch al in
   handen hebben, werken we meteen het telbolletje in de header bij: verwijder
   je iets in de lade, dan moet de header mee veranderen.

   Lukt het stempelen niet, dan doen we niets en werkt de cart zoals voorheen. */
(function () {
  'use strict';
  if (window.__afs7CartFix) return;
  window.__afs7CartFix = true;

  var CFG = window.__afs7CartText || {};

  function root() { return document.querySelector('[data-afs2k]'); }
  function inDrawer(el) { return !!(el.closest && el.closest('.afs7-dw')); }

  function tagLine(btn, item) {
    var line = btn.closest ? btn.closest('.afs2k-line') : null;
    if (!line || line.querySelector('.afs7-subtag')) return;
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    if (!plan) return;
    var tag = document.createElement('span');
    tag.className = 'afs7-subtag';
    tag.textContent = CFG.tag || 'Subscription';
    if (plan.name) tag.title = plan.name;
    var after = line.querySelector('.afs2k-line__v');
    if (after && after.parentNode) { after.parentNode.insertBefore(tag, after.nextSibling); }
    else { var b = line.querySelector('.afs2k-line__b') || line; b.insertBefore(tag, b.firstChild); }
  }

  function stamp() {
    var el = root();
    if (!el) return;
    var btns = el.querySelectorAll('[data-afs2k-qty]');
    if (!btns.length) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        for (var i = 0; i < btns.length; i++) {
          var n = parseInt(btns[i].getAttribute('data-afs2k-qty'), 10);
          var item = cart.items[n - 1];
          if (!item) continue;
          if (item.key) btns[i].setAttribute('data-afs7-key', item.key);
          tagLine(btns[i], item);
        }
        if (window.afs7PaintCount) {
          try { window.afs7PaintCount(cart.item_count); } catch (e) {}
        }
      })
      .catch(function () {});
  }

  function swap(html) {
    var el = root();
    if (!el) return;
    var box = document.createElement('div');
    box.innerHTML = html;
    var next = box.querySelector('[data-afs2k]');
    if (next) { el.replaceWith(next); } else { window.location.reload(); return; }
    // De verse sectie brengt de footer-verberger van de cartpagina opnieuw mee.
    if (window.afs7DrawerStrip) { try { window.afs7DrawerStrip(); } catch (e) {} }
    if (window.afs2Refresh) { try { window.afs2Refresh(); } catch (e) {} }
    document.dispatchEvent(new CustomEvent('afs2:cart-updated'));
    setTimeout(stamp, 0);
  }

  function post(url, payload, el) {
    payload.sections = el.getAttribute('data-section');
    payload.sections_url = '/cart';
    el.classList.add('is-busy');
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        var k = Object.keys(j.sections || {})[0];
        if (k) { swap(j.sections[k]); } else { window.location.reload(); }
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var el = root();
    if (!el) return;
    var t = e.target;
    if (!t.closest) return;

    /* Aantal en verwijderen: overal, want dit is de lijnsleutel-fix. */
    var q = t.closest('[data-afs2k-qty]');
    if (q && el.contains(q)) {
      var key = q.getAttribute('data-afs7-key');
      if (!key) return; // nog niet gestempeld: laat het thema het afhandelen
      e.preventDefault();
      e.stopPropagation(); // de regelnummer-versie van het thema overslaan
      post('/cart/change.js', { id: key, quantity: parseInt(q.getAttribute('data-to'), 10) }, el);
      return;
    }

    /* Cross-sell en tweede fles: alleen binnen de lade, want daar draait het
       script van het thema niet. Op de cartpagina zelf niets overnemen. */
    var a = t.closest('[data-afs2k-add]');
    if (a && el.contains(a) && inDrawer(a)) {
      e.preventDefault();
      e.stopPropagation();
      post('/cart/add.js', { items: [{ id: Number(a.getAttribute('data-afs2k-add')), quantity: 1 }] }, el);
      return;
    }

    var s = t.closest('[data-afs2k-swap]');
    if (s && el.contains(s) && inDrawer(s)) {
      var pair = (s.getAttribute('data-afs2k-swap') || '').split(':');
      if (pair.length !== 2) return;
      e.preventDefault();
      e.stopPropagation();
      var up = {};
      up[pair[0]] = 0;
      up[pair[1]] = 1;
      post('/cart/update.js', { updates: up }, el);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stamp, { once: true });
  } else { stamp(); }
  document.addEventListener('afs2:cart-updated', function () { setTimeout(stamp, 0); });
  document.addEventListener('afs7:drawer-filled', function () { setTimeout(stamp, 0); });
  document.addEventListener('shopify:section:load', function () { setTimeout(stamp, 0); });
  setTimeout(stamp, 1500);
})();